// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__xcKPI.styles_ocean-50__x7k4T {
  color: #e6f2ff;
}

.styles_color__xcKPI.styles_ocean-100__Ic3wN {
  color: #e6f2ff;
}

.styles_color__xcKPI.styles_ocean-200__eBdV6 {
  color: #b3daff;
}

.styles_color__xcKPI.styles_ocean-300__VAu3s {
  color: #7abfff;
}

.styles_color__xcKPI.styles_ocean-400__UxN1g {
  color: #2392fb;
}

.styles_color__xcKPI.styles_ocean-500__l49cR {
  color: #0074e0;
}

.styles_color__xcKPI.styles_ocean-600__bgTF8 {
  color: #043571;
}

.styles_color__xcKPI.styles_space-50__jTcsb {
  color: #f0f0f0;
}

.styles_color__xcKPI.styles_space-100__s6E9W {
  color: #e3e3e3;
}

.styles_color__xcKPI.styles_space-200__zWKzx {
  color: #bfbfbf;
}

.styles_color__xcKPI.styles_space-300__CbyC7 {
  color: gray;
}

.styles_color__xcKPI.styles_space-400__6AoRb {
  color: #616161;
}

.styles_color__xcKPI.styles_space-500__I7fnZ {
  color: #283439;
}

.styles_color__xcKPI.styles_gray-50__zzR0O {
  color: #eff3f6;
}

.styles_color__xcKPI.styles_gray-100__hsviQ {
  color: #e6ecef;
}

.styles_color__xcKPI.styles_gray-200__2c-34 {
  color: #cfd8de;
}

.styles_color__xcKPI.styles_gray-300__OmgAO {
  color: #a8b9c2;
}

.styles_color__xcKPI.styles_gray-400__Sc4GX {
  color: #7e98a5;
}

.styles_color__xcKPI.styles_gray-500__N88-O {
  color: #738f9c;
}

.styles_color__xcKPI.styles_green-50__3yush {
  color: #e3fdf6;
}

.styles_color__xcKPI.styles_green-100__nJBOM {
  color: #c5f6ea;
}

.styles_color__xcKPI.styles_green-200__f2SUc {
  color: #69ddc2;
}

.styles_color__xcKPI.styles_green-300__uyfBK {
  color: #45bfa3;
}

.styles_color__xcKPI.styles_green-400__j2zUp {
  color: #1cab8a;
}

.styles_color__xcKPI.styles_green-500__rVG8u {
  color: #128268;
}

.styles_color__xcKPI.styles_red-50__SQCiN {
  color: #fff0f3;
}

.styles_color__xcKPI.styles_red-100__3Fff8 {
  color: #f9d2db;
}

.styles_color__xcKPI.styles_red-200__crvSc {
  color: #f8b4c4;
}

.styles_color__xcKPI.styles_red-300__j28zR {
  color: #e85e81;
}

.styles_color__xcKPI.styles_red-400__F2PgD {
  color: #e23661;
}

.styles_color__xcKPI.styles_red-500__BShEY {
  color: #b82348;
}

.styles_color__xcKPI.styles_yellow-50__B\\+8Ff {
  color: #fffae6;
}

.styles_color__xcKPI.styles_yellow-100__gLARf {
  color: #fff0b3;
}

.styles_color__xcKPI.styles_yellow-200__roSci {
  color: #ffe380;
}

.styles_color__xcKPI.styles_yellow-300__2iwcT {
  color: #ffcf57;
}

.styles_color__xcKPI.styles_yellow-400__d7mT\\+ {
  color: #ffc60a;
}

.styles_color__xcKPI.styles_yellow-500__csaBT {
  color: #ffb700;
}

.styles_color__xcKPI.styles_orange-50__F2Op- {
  color: #fff2eb;
}

.styles_color__xcKPI.styles_orange-100__qbyXx {
  color: #ffe4d6;
}

.styles_color__xcKPI.styles_orange-200__iUqaT {
  color: #ffc69e;
}

.styles_color__xcKPI.styles_orange-300__Qeyju {
  color: #ffa047;
}

.styles_color__xcKPI.styles_orange-400__PXENl {
  color: #ff7b42;
}

.styles_color__xcKPI.styles_orange-500__Rbz-V {
  color: #ee4920;
}

.styles_color__xcKPI.styles_turquoise-50__5pmbR {
  color: transparent;
}

.styles_color__xcKPI.styles_turquoise-100__FoNnw {
  color: #e6fcff;
}

.styles_color__xcKPI.styles_turquoise-200__SkVlI {
  color: #b3f5ff;
}

.styles_color__xcKPI.styles_turquoise-300__f1TSq {
  color: #78e2f2;
}

.styles_color__xcKPI.styles_turquoise-400__8A2x8 {
  color: #00c7e6;
}

.styles_color__xcKPI.styles_turquoise-500__rSbDq {
  color: transparent;
}

.styles_color__xcKPI.styles_turquoise-600__NGdjn {
  color: transparent;
}

.styles_color__xcKPI.styles_violet-50__JMtXJ {
  color: #eae6ff;
}

.styles_color__xcKPI.styles_violet-100__Met-7 {
  color: #d9d1ff;
}

.styles_color__xcKPI.styles_violet-200__Vxm2C {
  color: #bfb3ff;
}

.styles_color__xcKPI.styles_violet-300__KUR8R {
  color: #9d90ea;
}

.styles_color__xcKPI.styles_violet-400__-his- {
  color: #8678d9;
}

.styles_color__xcKPI.styles_violet-500__yHKlb {
  color: #6f5ccc;
}

.styles_color__xcKPI.styles_snow-50__lsmBf {
  color: white;
}

.styles_color__xcKPI.styles_snow-100__jP2xT {
  color: #f7f7f7;
}

.styles_color__xcKPI.styles_snow-200__QA1R8 {
  color: #f0efef;
}

.styles_color__xcKPI.styles_snow-300__mI3d4 {
  color: #e6e6e6;
}

.styles_color__xcKPI.styles_snow-400__yTYxz {
  color: #e1e0e0;
}

.styles_color__xcKPI.styles_snow-500__CJ6-B {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__YXIcB.styles_ocean__MT3q4 {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__YXIcB.styles_ocean-light__Ofees {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__YXIcB.styles_green__OdBOq {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__YXIcB.styles_green-light__OpE-E {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__YXIcB.styles_red__oVOWg {
  background-color: #e23661;
  color: white;
}

.styles_background-color__YXIcB.styles_red-light__2VHEC {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__YXIcB.styles_orange__1jKZv {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__YXIcB.styles_orange-light__SWTCP {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__YXIcB.styles_space__qmk7r {
  background-color: #616161;
  color: white;
}

.styles_background-color__YXIcB.styles_space-light__3S\\+EA {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__YXIcB.styles_gray-light__TBCP5 {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__YXIcB.styles_violet__Kh3U6 {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__YXIcB.styles_violet-light__ZNGyp {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__YXIcB.styles_yellow__IrTEh {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__YXIcB.styles_yellow-light__07jOc {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
/* stylelint-disable-next-line max-line-length */
/* TODO: Having different line-heights causes some UI and spacing issues.
 * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.
*/
.styles_root__eRTXo {
  background-color: white;
  border-bottom: 2px solid #eff3f6;
}

.styles_title__1mFoJ {
  color: #616161;
  padding: 4px 20px ;
}
.styles_title__1mFoJ.styles_selected__VOOmh {
  font-weight: 600;
  font-size: 0.8571428571rem;
  letter-spacing: 0.02em;
  line-height: 2.15;
  color: #0074e0;
}
.styles_title__1mFoJ.styles_selected__VOOmh::before {
  background-color: #0074e0;
  border-radius: 20px;
  bottom: 0;
  content: "";
  height: 2px;
  left: 0;
  position: absolute;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/sidebar/categories/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography_old.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ACXA,gDAAA;AASA;;CAAA;AFZA;EACI,uBAAA;EACA,gCAAA;AA8UJ;;AA3UA;EACI,cAAA;EACA,kBAAA;AA8UJ;AA5UI;EEuCA,gBAAA;EAPA,0BAAA;EACA,sBAciB;EAbjB,iBAaiB;EF5Cb,cAAA;AAgVR;AA9UQ;EACI,yBAAA;EAGA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AA8UZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme_old';\n\n.root {\n    background-color: theme_old.color(snow-50);\n    border-bottom: 2px solid theme_old.color(gray-50);\n}\n\n.title {\n    color: theme_old.color(space-400);\n    padding: theme_old.spacing(0.5, 2.5);\n\n    &.selected {\n        @include theme_old.typo-old(subtitle2);\n\n        color: theme_old.color(ocean-500);\n\n        &::before {\n            background-color: theme_old.color(ocean-500);\n\n            // TODO: We don't such a value (20px) for border-radius in our design system.\n            border-radius: 20px;\n            bottom: 0;\n            content: '';\n            height: 2px;\n            left: 0;\n            position: absolute;\n            width: 100%;\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n/* stylelint-disable-next-line max-line-length */\n$typography-font-family: 'Open Sans', system-ui, -apple-system, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Cantarell', 'Helvetica Neue';\n$typography-font-weights: (\n    light: 300,\n    normal: 400,\n    semi-bold: 600,\n    bold: 700\n);\n\n/* TODO: Having different line-heights causes some UI and spacing issues.\n * They should be consistent. Please investigate this when refactoring/reimplementing the Typography.\n*/\n$typography-variants: (\n    h1: 60px semi-bold 1.36 -0.03em,\n    h2: 48px semi-bold 1.5 -0.025,\n    h3: 34px semi-bold 1.6 -0.02em,\n    h4: 24px semi-bold 1.7 -0.015em,\n    h5: 20px semi-bold 1.8 -0.0125em,\n    h6: 16px semi-bold 1.9 -0.01em,\n    subtitle1: 14px semi-bold 2 0.01em,\n    subtitle2: 12px semi-bold 2.15 0.02em,\n    subtitle3: 10px semi-bold 2.4 0.04em,\n    body1: 14px regular 2 0.01em,\n    body2: 12px regular 2.15 0.02em,\n    body3: 10px regular 2.4 0.04em,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing, $text-transform: null) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n    text-transform: $text-transform;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo-old($variant, $includeFontFamily: false) {\n    @if $includeFontFamily {\n        font-family: $typography-font-family;\n    }\n\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__xcKPI`,
	"ocean-50": `styles_ocean-50__x7k4T`,
	"ocean-100": `styles_ocean-100__Ic3wN`,
	"ocean-200": `styles_ocean-200__eBdV6`,
	"ocean-300": `styles_ocean-300__VAu3s`,
	"ocean-400": `styles_ocean-400__UxN1g`,
	"ocean-500": `styles_ocean-500__l49cR`,
	"ocean-600": `styles_ocean-600__bgTF8`,
	"space-50": `styles_space-50__jTcsb`,
	"space-100": `styles_space-100__s6E9W`,
	"space-200": `styles_space-200__zWKzx`,
	"space-300": `styles_space-300__CbyC7`,
	"space-400": `styles_space-400__6AoRb`,
	"space-500": `styles_space-500__I7fnZ`,
	"gray-50": `styles_gray-50__zzR0O`,
	"gray-100": `styles_gray-100__hsviQ`,
	"gray-200": `styles_gray-200__2c-34`,
	"gray-300": `styles_gray-300__OmgAO`,
	"gray-400": `styles_gray-400__Sc4GX`,
	"gray-500": `styles_gray-500__N88-O`,
	"green-50": `styles_green-50__3yush`,
	"green-100": `styles_green-100__nJBOM`,
	"green-200": `styles_green-200__f2SUc`,
	"green-300": `styles_green-300__uyfBK`,
	"green-400": `styles_green-400__j2zUp`,
	"green-500": `styles_green-500__rVG8u`,
	"red-50": `styles_red-50__SQCiN`,
	"red-100": `styles_red-100__3Fff8`,
	"red-200": `styles_red-200__crvSc`,
	"red-300": `styles_red-300__j28zR`,
	"red-400": `styles_red-400__F2PgD`,
	"red-500": `styles_red-500__BShEY`,
	"yellow-50": `styles_yellow-50__B+8Ff`,
	"yellow-100": `styles_yellow-100__gLARf`,
	"yellow-200": `styles_yellow-200__roSci`,
	"yellow-300": `styles_yellow-300__2iwcT`,
	"yellow-400": `styles_yellow-400__d7mT+`,
	"yellow-500": `styles_yellow-500__csaBT`,
	"orange-50": `styles_orange-50__F2Op-`,
	"orange-100": `styles_orange-100__qbyXx`,
	"orange-200": `styles_orange-200__iUqaT`,
	"orange-300": `styles_orange-300__Qeyju`,
	"orange-400": `styles_orange-400__PXENl`,
	"orange-500": `styles_orange-500__Rbz-V`,
	"turquoise-50": `styles_turquoise-50__5pmbR`,
	"turquoise-100": `styles_turquoise-100__FoNnw`,
	"turquoise-200": `styles_turquoise-200__SkVlI`,
	"turquoise-300": `styles_turquoise-300__f1TSq`,
	"turquoise-400": `styles_turquoise-400__8A2x8`,
	"turquoise-500": `styles_turquoise-500__rSbDq`,
	"turquoise-600": `styles_turquoise-600__NGdjn`,
	"violet-50": `styles_violet-50__JMtXJ`,
	"violet-100": `styles_violet-100__Met-7`,
	"violet-200": `styles_violet-200__Vxm2C`,
	"violet-300": `styles_violet-300__KUR8R`,
	"violet-400": `styles_violet-400__-his-`,
	"violet-500": `styles_violet-500__yHKlb`,
	"snow-50": `styles_snow-50__lsmBf`,
	"snow-100": `styles_snow-100__jP2xT`,
	"snow-200": `styles_snow-200__QA1R8`,
	"snow-300": `styles_snow-300__mI3d4`,
	"snow-400": `styles_snow-400__yTYxz`,
	"snow-500": `styles_snow-500__CJ6-B`,
	"background-color": `styles_background-color__YXIcB`,
	"ocean": `styles_ocean__MT3q4`,
	"ocean-light": `styles_ocean-light__Ofees`,
	"green": `styles_green__OdBOq`,
	"green-light": `styles_green-light__OpE-E`,
	"red": `styles_red__oVOWg`,
	"red-light": `styles_red-light__2VHEC`,
	"orange": `styles_orange__1jKZv`,
	"orange-light": `styles_orange-light__SWTCP`,
	"space": `styles_space__qmk7r`,
	"space-light": `styles_space-light__3S+EA`,
	"gray-light": `styles_gray-light__TBCP5`,
	"violet": `styles_violet__Kh3U6`,
	"violet-light": `styles_violet-light__ZNGyp`,
	"yellow": `styles_yellow__IrTEh`,
	"yellow-light": `styles_yellow-light__07jOc`,
	"root": `styles_root__eRTXo`,
	"title": `styles_title__1mFoJ`,
	"selected": `styles_selected__VOOmh`
};
export default ___CSS_LOADER_EXPORT___;
